import { camelCase, snakeCase } from 'change-case'
import $cookies from 'vue-cookies'
// import camelCaseKeys from 'camelcase-keys'
// import snakecaseKeys from 'snakecase-keys'

/**
 * 텍스트 복사
 * @param value
 */
export const textCopy = (value) => {
  const el = document.createElement('textArea')
  document.body.appendChild(el)
  el.value = value
  el.select()
  document.execCommand('Copy')
  el.remove()
}

export const jsLoad = async (attr) => {
  return new Promise((resolve, reject) => {
    const org = document.getElementById(attr.id)
    if (org) {
      resolve(org)
      return
    }
    const sc = document.createElement('script')
    for (const key in attr) {
      sc[key] = attr[key]
    }

    sc.onload = () => {
      resolve(sc)
    }
    sc.onerror = () => {
      reject(new Error('script load error'))
    }

    document.head.appendChild(sc)
  })
}

export const cssLoad = (attr) => {
  return new Promise((resolve, reject) => {
    const org = document.getElementById(attr.id)
    if (org) {
      resolve(org)
      return
    }
    const sc = document.createElement('link')
    sc.rel = 'stylesheet'
    sc.type = 'text/css'

    for (const key in attr) {
      sc[key] = attr[key]
    }

    sc.onload = () => {
      resolve(sc)
    }
    sc.onerror = () => {
      reject(new Error('script load error'))
    }

    document.head.appendChild(sc)
  })
}

export const simpleClone = (obj) => {
  return JSON.parse(JSON.stringify(obj))
}

export const sleep = (m) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(m)
    }, m)
  })
}

export const uuid = () => {
  function s4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4()
}

export const getRedirectUri = (to) => {
  let uri
  if (to) {
    uri = to.fullPath
  } else {
    uri = location.pathname + location.search
  }
  return uri
}

export const camelCaseKeys = (v) => {
  if (Array.isArray(v)) {
    for (let i = 0; i < v.length; i++) {
      v[i] = camelCaseKeys(v[i])
    }
    return v
  }
  if (typeof v === 'object') {
    const o = {}
    for (const k in v) {
      o[camelCase(k)] = v[k]
    }
    for (const k in o) {
      if (o[k] && typeof o[k] === 'object') {
        o[k] = camelCaseKeys(o[k])
      }
    }
    return o
  }
  return v
}

export const snakeCaseKeys = (v) => {
  if (Array.isArray(v)) {
    for (let i = 0; i < v.length; i++) {
      v[i] = snakeCaseKeys(v[i])
    }
    return v
  } else if (typeof v === 'object') {
    const o = {}
    for (const k in v) {
      o[snakeCase(k)] = v[k]
    }
    for (const k in o) {
      if (o[k] && typeof o[k] === 'object') {
        o[k] = snakeCaseKeys(o[k])
      }
    }
    return o
  }
  return v
}

export const locationRedirect = (redirect) => {
  if (navigator.userAgent.match(/Android/i)) {
    document.location.replace(redirect)
  } else {
    location.href = redirect
  }
}

export const closeBrowser = () => {
  return (
    window?.Android?.closeBrowser?.() ??
    window?.webkit?.messageHandlers?.closeBrowser?.postMessage?.('')
  )
}

export const dataURIToBlob = (dataURI) => {
  const splitDataURI = dataURI.split(',')
  const byteString =
    splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1])
  const mimeString = splitDataURI[0].split(':')[1].split(';')[0]
  const ia = new Uint8Array(byteString.length)
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i)
  }
  return new Blob([ia], { type: mimeString })
}

export const sortAsc = (array, fieldName) => {
  return sort(array, fieldName, true)
}

export const sortDesc = (array, fieldName) => {
  return sort(array, fieldName, false)
}

export const sort = (array, fieldName, isAsc) => {
  if (!array) return []

  const newAray = simpleClone(array)
  return newAray.sort((a, b) => {
    if (a[fieldName] > b[fieldName]) {
      return isAsc ? 1 : -1
    } else if (a[fieldName] < b[fieldName]) {
      return isAsc ? -1 : 1
    }
    return 0
  })
}

/**
 * 파일 이름 추출
 * @param {*} filePath
 * @returns
 */
export const extractFileName = (filePath) => {
  // 경로 문자열에서 역슬래시(\) 또는 슬래시(/)로 분할하여 배열로 만듭니다.
  const pathParts = filePath.split(/[\\\/]/)

  // 배열의 마지막 요소가 파일 이름입니다.
  const fileName = pathParts[pathParts.length - 1]

  return fileName
}

/**
 * 파일 확장자 추출
 * @param {*} filePath
 * @returns
 */
export const extractFileExtension = (filePath) => {
  // 파일 이름을 추출합니다.
  const fileName = extractFileName(filePath)

  // 파일 이름을 마침표(.)로 분할하여 배열로 만듭니다.
  const fileNameParts = fileName.split('.')

  // 배열의 마지막 요소가 확장자입니다.
  if (fileNameParts.length > 1) {
    const fileExtension = fileNameParts[fileNameParts.length - 1]
    return fileExtension
  } else {
    // 마침표가 없는 경우 확장자가 없음을 나타내는 빈 문자열을 반환합니다.
    return ''
  }
}

/**
 * 이미지 파일 여부 판별
 * @param {*} filePath
 * @returns
 */
export const isImageFile = (filePath) => {
  // 파일 확장자를 추출합니다.
  const fileExtension = extractFileExtension(filePath)

  // 일반적인 이미지 파일 확장자들을 배열로 만듭니다.
  const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp']

  // 파일 확장자를 소문자로 변환한 후, 이미지 확장자 배열과 비교합니다.
  return imageExtensions.includes(fileExtension.toLowerCase())
}

export const getRedirectUriAndRemove = () => {
  const redirectUriName = 'redirectUri'
  const redirectUri = $cookies.get(redirectUriName)
  $cookies.remove(redirectUriName)
  return redirectUri
}

export default {
  textCopy,
  simpleClone,
  cssLoad,
  jsLoad,
  sleep,
  uuid,
  getRedirectUri,
  camelCaseKeys,
  snakeCaseKeys,
  camelCase,
  snakeCase,
  locationRedirect,
  closeBrowser,
}
